// Bootstrap shims that replace Webpack build-time plugins. Imported first by
// every app entry (the public path itself is now handled by Vite's `base`).
import strings from './strings.json';

// Replaces embed-i18n-webpack-plugin: `__('key')` was inlined at build time;
// here it's a runtime lookup against the single strings file.
window.__ = (key) => (key in strings ? strings[key] : key);

// Replaces html-webpack-inline-svg-plugin: inject the icon sprite so that
// `<use href="#icon-*">` references resolve. Only needed when running the
// explorer standalone; in production the host CMS page already provides the
// sprite, so the dynamic import keeps it out of the bundle.
if (import.meta.env.DEV) {
  import('@chh/ui/artifacts/icons.svg?raw').then(({ default: iconSprite }) => {
    const spriteHost = document.createElement('div');
    spriteHost.setAttribute('aria-hidden', 'true');
    spriteHost.style.display = 'none';
    spriteHost.innerHTML = iconSprite;
    document.body.prepend(spriteHost);
  });
}
